import renameKeyOfObjectOrSetValue from "../renameKeyOfObjectOrSetValue";
// Transform block tree state api to block server api
const BlockActionApiTransformer = (origin) => {

    const data = { ...origin };

    renameKeyOfObjectOrSetValue(data, { old_key : 'body', new_key : 'api_body'})
    renameKeyOfObjectOrSetValue(data, { new_key : 'api_body_type' }, data.api_body_type.name)
    renameKeyOfObjectOrSetValue(data, { new_key : 'api_method_type'}, data.api_method_type.name)
    renameKeyOfObjectOrSetValue(data, { old_key : 'headers', new_key : 'api_headers'})
    renameKeyOfObjectOrSetValue(data, { old_key : 'responses', new_key : 'api_responses'})
    renameKeyOfObjectOrSetValue(data, { old_key : 'url', new_key : 'api_url'})
    
    return data; 
}

export default BlockActionApiTransformer;